// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"abb884116782a64c39f8","453":"d9fec9e2af503e323d53","454":"2b9835b75a4e1a396cbb"}[chunkId] + ".js";
};